// GrooveMail sender ids are Mongo ObjectIds. Number("507f1f77bcf86cd799439011")
// is NaN, so a numeric check rejects a verified sender and hides a saved one.

export const CUSTOM_SENDER_ERROR = 'Choose a verified sender or use the default sender.';

export function hasSelectedSender(senderId) {
  if (senderId === null || senderId === undefined) {
    return false;
  }

  const value = String(senderId).trim();

  return value !== '' && value !== '0';
}

export function senderTypeFor(senderId) {
  return hasSelectedSender(senderId) ? 'custom' : 'default';
}

// The default sender always works: buyer emails then go out from the platform address
// under the seller's name, with replies to the seller. Live funnels may use it.
export function customSenderError(senderType, senderId) {
  if (senderType === 'custom' && !hasSelectedSender(senderId)) {
    return CUSTOM_SENDER_ERROR;
  }

  return '';
}

export function senderIdForSave(senderType, senderId) {
  return senderType === 'default' ? 0 : senderId;
}
